import { AccessRights, AccessRightsStorageInterface, CoreConfigurationInterface, DandelionService, HeaderProviderInterface, NamedBindings } from "@dandelion/core";
import axios, { AxiosInstance } from "axios";
import { injectable, inject } from "inversify";

//TODO remove when core is updated to 0.9.4 or higher
@injectable()
export class RESTAccessRightsStorageforProsafe extends DandelionService implements AccessRightsStorageInterface {

    private readonly BASE_URL: string;
    private accessRightsCache: Map<string, AccessRights> | null = null;
    private cacheExpiry: Date = new Date(0); // Expired initially
    private axiosInstance: AxiosInstance;

    constructor(
        @inject(NamedBindings.HeaderProvider) protected HeaderProvider: HeaderProviderInterface,
        @inject(NamedBindings.CoreConfiguration) protected coreConfiguration: CoreConfigurationInterface
    ) {
        super();
        this.BASE_URL = `${this.coreConfiguration.baseUrlForAccessRights}all-access-rights/`;

        this.axiosInstance = axios.create();
        this.axiosInstance.interceptors.request.use((config: any) => {
            config.headers = this.HeaderProvider.getHeaders();
            return config;
        });
    }

    async getAccessRights(): Promise<Map<string, AccessRights>> {
        // Return cached data if not expired
        if (this.accessRightsCache && new Date() < this.cacheExpiry) {
            return this.accessRightsCache;
        }

        try {
            const response = await this.axiosInstance.get(this.BASE_URL);
            const accessRightsData: Record<string, AccessRights> = response.data;
            const accessRightsMap = transformRoles(accessRightsData);
            this.accessRightsCache = new Map(Object.entries(accessRightsMap));
            this.cacheExpiry = new Date(Date.now() + 60 * 60 * 1000); // Cache expires in 60 minutes

            return this.accessRightsCache;
        } catch (error) {
            console.error('Error fetching access rights:', error);
            throw new Error('Failed to fetch access rights');
        }
    }

    clearCache(): void {
        this.accessRightsCache = null;
        this.cacheExpiry = new Date(0); // Mark cache as expired
    }
}
function transformRoles(obj: Record<string, any>): Record<string, any> {
    return Object.fromEntries(
        Object.entries(obj).map(([key, value]) => {
            if (typeof value === "object" && value !== null) {
                return [
                    key,
                    {
                        read_roles: value.ReadRoles,
                        write_roles: value.WriteRoles
                    }
                ];
            }
            return [key, value];
        })
    );
}
